import { FC } from 'react';
import { useModalContext } from 'src/hooks/useModalContext';
import { getCurrentLanguageObject } from 'src/modules/locales/utils/getCurrentLanguageObject';

interface LanguagesSelectorProps {
  compact?: boolean;
}

export const LanguagesSelector: FC<LanguagesSelectorProps> = ({ compact = false }) => {
  const currentLanguage = getCurrentLanguageObject();

  const { openModal } = useModalContext();

  const handleSelectorClick = () => openModal('LANGUAGES');

  return compact ? (
    <div className="z-20 cursor-pointer" onClick={handleSelectorClick}>
      {currentLanguage?.icon && <currentLanguage.icon className="!h-10 !w-10 rounded-full" />}
    </div>
  ) : (
    <div
      className="w-full flex justify-center items-center gap-2 h-10 bg-ls_bg border border-solid border-ls_border hover:border-ls_border_hovered transition-colors duration-200 cursor-pointer rounded"
      onClick={handleSelectorClick}>
      {currentLanguage?.icon && <currentLanguage.icon className="!h-6 !w-6 rounded-full" />}
      <p className="text-base font-medium text-ls_title">{currentLanguage?.labelName}</p>
    </div>
  );
};
